import { Link } from '@tanstack/react-router';
import type { MargensItemAbaixoLinha } from '@triade/contracts';
import { ProfitBadge } from '@/components/profit-badge';

/** Lateral do design: "Itens negociados abaixo da meta" (os de menor lucro). Cada item abre o orcamento de origem. */
export function ListaItensAbaixo({ itens }: { itens: MargensItemAbaixoLinha[] }) {
  return (
    <ul className="m-0 flex list-none flex-col gap-3 p-0" aria-label="Itens negociados abaixo da meta">
      {itens.map((i) => (
        <li key={`${i.orcamentoId}-${i.seq}`} className="flex items-center justify-between gap-2" data-testid="item-abaixo">
          <div className="min-w-0">
            <div className="truncate text-small">
              {i.codigo} · {i.descricao}
            </div>
            <div className="text-caption text-ink-muted">
              <Link to="/vender/orcamentos/$id" params={{ id: i.orcamentoId }} className="font-medium text-primary hover:underline">
                Orç. {i.orcamentoNumero}
              </Link>
              {i.clienteNome ? ` · ${i.clienteNome}` : ''} · {i.tabelaNome}
            </div>
          </div>
          <ProfitBadge lucro={i.exibicao.lucro} faixa={i.faixa} meta={i.exibicao.metaLucro} minimo={i.exibicao.minimoLucro} compacto />
        </li>
      ))}
    </ul>
  );
}
